import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Row, Col, Button, FormGroup, Radio } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  setPaymentPlanType,
  setSubscriptionMethod,
  setGiftFormStatus,
  setLandingScrollPosition,
} from '../../redux/actionCreators';

let SubscriptionMethods = props => {
  const {
    history,
    authenticated,
    showGiftForm,
    payment_plan_type,
    setPaymentPlanType,
    handleSubscriptionMethodSelect,
    handleGiftFormStatusShow,
  } = props;

  const selectSubscriptionMethod = subscription_method => {
    handleSubscriptionMethodSelect(subscription_method);
    history.push('/register');
  };

  const goToGiftForm = () => {
    handleGiftFormStatusShow(true);
    selectSubscriptionMethod('web');
  };

  const handleRegisterClick = subscription_method => {
    showGiftForm && handleGiftFormStatusShow(false);

    selectSubscriptionMethod(subscription_method);
  };

  /* !!!
    CSS class 'price-month' should be renamed as it is quite confusing and doesn't display the content
  */

  const definePrice = () => {
    if (payment_plan_type === 'yearly') {
      return (
        <p className="price-text">
          &#36;49
          <sup className="price-month">/year</sup>
        </p>
      );
    } else {
      return (
        <p className="price-text">
          &#36;4.99
          <sup className="price-month">/month</sup>
        </p>
      );
    }
  };

  return (
    <div className={`main-subscription-grid ${authenticated ? 'authenticated' : ''}`}>
      <h2 className="subscription-h2-grid">Select Subscription Method</h2>
      <div className="promos clearfix">
        <div className="promo first">
          <h4 className="first-h4">Subscription Details</h4>

          {/* !!!
            The following inline styles were added just for testing purposes.
            Please, REMOVE them (and this comment also) when styling this section.
            */}
          <div className="first-plan">
            <FormGroup className="choice-plan">
              <Col md={3} xs={6} className="sb-radio sb-radio-1">
                <Radio
                  className="radio"
                  name="radioGroup"
                  inline
                  checked={payment_plan_type === 'monthly'}
                  onChange={() => setPaymentPlanType('monthly')}
                >
                  <span className="radio-text" />
                  <span className="choice-radio">Monthly</span>
                </Radio>
              </Col>
              <Col md={9} xs={6} className="sb-radio sb-radio-2">
                <Radio
                  className="radio"
                  name="radioGroup"
                  inline
                  checked={payment_plan_type === 'yearly'}
                  onChange={() => setPaymentPlanType('yearly')}
                >
                  <span className="radio-text" />
                  <span className="choice-radio">
                    Annual <br />
                    <sup className="price-month">(2 months free)</sup>{' '}
                  </span>
                </Radio>
              </Col>
            </FormGroup>
          </div>
          <span className="brief" />
          <hr />
          <ul className="features">
            <li>Customizable, personal library</li>
            <li className="second-li ipad-li">Unique, user-tested training techniques</li>
            <li>Easy, 1-click review</li>
            <li className="second-li">Automated delivery</li>
            <li>Exercises in your email inbox</li>
            <li className="second-li">Fillable, savable PDFs</li>
            <li className="ipad-li">Exercises directly to your phone (iPhone only)</li>
            <li className="second-li last-li-mb">Convenient customizable reminders</li>
          </ul>
        </div>

        <div className="promo third scale">
          <h4>Web Subscription</h4>

          {definePrice()}

          <hr />
          <ul className="features">
            <li className="second-li dk-hide">Customizable, personal library</li>
            <li className="gl-ok">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide mobile-white">Unique, user-tested training techniques</li>
            <li className="second-li gl-ok ipad-li">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide">Easy, 1-click review</li>
            <li className="gl-ok">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide mobile-white">Automated delivery</li>
            <li className="second-li gl-ok last-li">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide">Exercises in your email inbox</li>
            <li className="gl-ok last-li">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide mobile-white">Fillable, savable PDFs</li>
            <li className="second-li gl-ok last-li">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide" />
            <li className="gl-ok last-li and-li ipad-li">{/*<span className="span-ok"/>*/}</li>

            <li className="second-li dk-hide mobile-white" />
            <li className="second-li gl-ok last-li and-li">{/*<span className="span-ok"/>*/}</li>

            {!authenticated && (
              <div className="buy">
                <Button bsStyle="info" className="third-btn" onClick={() => handleRegisterClick('web')}>
                  Register
                </Button>
              </div>
            )}
          </ul>
        </div>
        <div className="promo second">
          <h4>Mobile Subscription</h4>

          {definePrice()}

          <hr />
          <ul className="features">
            <li className="second-li dk-hide">Customizable, personal library</li>
            <li className="gl-ok">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide mobile-white">Unique, user-tested training techniques</li>
            <li className="second-li gl-ok ipad-li">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide">Easy, 1-click review</li>
            <li className="gl-ok">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide mobile-white">Automated delivery</li>
            <li className="second-li gl-ok">
              <span className="span-ok" />
            </li>

            <li className="second-li dk-hide hide-on-mobile" />
            <li className="gl-ok">{/*<span className="span-ok"/>*/}</li>

            <li className="second-li dk-hide mobile-white hide-on-mobile" />
            <li className="second-li gl-ok" />

            <li className="second-li dk-hide">Exercises directly to your phone (iPhone only)</li>
            <li className="gl-ok ipad-li">
              <span className="span-ok" />
            </li>

            {/*<li className="second-li" />*/}
            {/*<li className="second-li gl-ok and-ok">*/}
            <li className="second-li dk-hide mobile-white">Convenient customizable reminders</li>
            <li className="second-li gl-ok">
              <span className="span-ok" />
            </li>
            <p className="promo-text">
              <a
                href="https://itunes.apple.com/us/app/presence-walk-with-god/id1400174335?l=ru&ls=1&mt=8"
                target="_blank"
                style={{ color: '#202020' }}
              >
                Download Presence on the Apple App Store
              </a>
            </p>

            {!authenticated && (
              <div className="buy buy-mobile">
                <Button bsStyle="info" onClick={() => handleRegisterClick('mobile')}>
                  Register
                </Button>
              </div>
            )}
          </ul>
        </div>

        <div className="promo fourth">
          <div className="gift-header">
            <h4>Gift Subscription</h4>

            <p className="price-text">
              &#36;49
              <sup className="price-month">/year</sup>
            </p>

            <hr />
          </div>
          <div className="gift-row">
            <div className="gift-bg">
              <div className="gift-in">
                <p className="gift-first-p">
                  How would <strong>a full year of walking in God’s presence</strong> bless your friends and family?
                </p>
                <p className="gift-in-p" onClick={goToGiftForm}>
                  To gift 1-year subscriptions to others click here.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  showGiftForm: state.registration.showGiftForm,
  payment_plan_type: state.user.payment_plan_type,
});

const mapDispatchToProps = (dispatch: Function) => ({
  setPaymentPlanType(type) {
    dispatch(setPaymentPlanType(type));
  },

  handleSubscriptionMethodSelect(subscription_method) {
    dispatch(setSubscriptionMethod(subscription_method));
    dispatch(setLandingScrollPosition(''));
  },

  handleGiftFormStatusShow(is_gift) {
    dispatch(setGiftFormStatus(is_gift));
    dispatch(setLandingScrollPosition(''));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SubscriptionMethods),
);



// WEBPACK FOOTER //
// ./src/components/Landing/SubscriptionMethods.js